import actionTypes from 'SRC/modules/redux/actionTypes'

export const setIsCategoryPage = (isCategoryPage = false) => {
  return {
    type: actionTypes.SET_IS_CATEGORY_PAGE,
    payload: isCategoryPage
  }
}
